import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: { backToTop: "Volver arriba" },
  en: { backToTop: "Back to top" },
});
